import React from 'react';
import { useSelector } from 'react-redux';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { Link } from 'react-router-dom';

import useCart from '../../store/cart/useCart';
import useNavigation from '../../../utils/useNavigation';
import useSidebar from './useSidebar';
import { Banana, Earth } from '../../../ui-library/typography';
import { Space } from '../../../ui-library/space';

import { Box } from '../../../ui-library/layout';
import { Button } from '../../../ui-library/buttons';
import { ButtonCloseNoBorderIcon, CartIcon } from '../../../ui-library/icons';
import CartLink from '../../header-navigation/CartLink';
import LoginRegisterLinks from '../../header-navigation/LoginRegisterLinks';
import useAuth from '../../auth/useAuth';
import { menuItems } from './utils.menuItems';
import styled from 'styled-components';

const StyledCloseButtonDiv = styled.div`
  margin-top: 4px;
`;

const SignedInLinks = ({ hideSidebar }) => {
  const { logout, isAdmin } = useAuth();

  return (
    <AccordionItemPanel style={{ marginTop: '-16px' }}>
      <Link
        to='/dashboard'
        className='menu-sidebar-sub-item'
        onClick={hideSidebar}
      >
        <Earth>Dashboard</Earth>
        <Space size={4} />
      </Link>
      <Link
        to='/orders'
        className='menu-sidebar-sub-item'
        onClick={hideSidebar}
      >
        <Earth>Orders</Earth>
        <Space size={4} />
      </Link>
      <Link
        to='/profile'
        className='menu-sidebar-sub-item'
        onClick={hideSidebar}
      >
        <Earth>Profile</Earth>
        <Space size={4} />
      </Link>
      {isAdmin && (
        <Link
          to='/admin'
          className='menu-sidebar-sub-item'
          onClick={hideSidebar}
        >
          <Earth>Admin</Earth>
          <Space size={4} />
        </Link>
      )}
      <Link to='/#' className='menu-sidebar-sub-item' onClick={logout}>
        <Earth>Logout</Earth>
        <Space size={4} />
      </Link>
    </AccordionItemPanel>
  );
};

const SignedOutLinks = ({ hideSidebar }) => (
  <AccordionItemPanel style={{ marginTop: '-16px' }}>
    <LoginRegisterLinks hideSidebar={hideSidebar} />
  </AccordionItemPanel>
);

const SidebarContent = () => {
  const { hasItems } = useCart();
  const [, , , hideSidebar] = useSidebar();
  const { goToStore } = useNavigation();
  const user = useSelector((state) => state.auth);

  const handleStartShopping = () => {
    hideSidebar();
    goToStore();
  };

  return (
    <>
      <Box justifyContent='space-between' alignItems='start'>
        <StyledCloseButtonDiv>
          <Button icon={<ButtonCloseNoBorderIcon />} onClick={hideSidebar} />
        </StyledCloseButtonDiv>
        <CartLink />
      </Box>
      <Space size={16} />
      <Accordion>
        <AccordionItem>
          <AccordionItemHeading>
            <AccordionItemButton className='menu-sidebar-item'>
              <Banana textTransform='uppercase'>My Account</Banana>
            </AccordionItemButton>
          </AccordionItemHeading>
          {user ? (
            <SignedInLinks hideSidebar={hideSidebar} />
          ) : (
            <SignedOutLinks hideSidebar={hideSidebar} />
          )}
        </AccordionItem>
        {menuItems.map((ele) => {
          return (
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton className='menu-sidebar-item'>
                  <Banana textTransform='uppercase'>{ele.title}</Banana>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel style={{ marginTop: '-16px' }}>
                {ele.content.map((item, index) =>
                  item.link ? (
                    <Link
                      key={index}
                      to={item.link}
                      className='menu-sidebar-sub-item'
                      onClick={hideSidebar}
                    >
                      <Earth>{item.title}</Earth>
                      <Space size={4} isFixed />
                    </Link>
                  ) : (
                    <a
                      href={item.url}
                      className='menu-sidebar-sub-item'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <Earth>{item.title}</Earth>
                      <Space size={4} isFixed />
                    </a>
                  )
                )}
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </>
  );
};

export default SidebarContent;
